import { render, staticRenderFns } from "./medicalPreview.vue?vue&type=template&id=3c85f2c6&scoped=true&"
import script from "./medicalPreview.vue?vue&type=script&lang=js&"
export * from "./medicalPreview.vue?vue&type=script&lang=js&"
import style0 from "./medicalPreview.vue?vue&type=style&index=0&id=3c85f2c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c85f2c6",
  null
  
)

export default component.exports